module.exports = __webpack_public_path__ + "static/media/statistics.75477ee0.png";